// components/Products.js
import React, { useState } from 'react';
import { Link } from "react-router-dom";

const catMeta = {
  tablets:    { icon: 'ti-pill',    bar: 'linear-gradient(90deg,#1D9E75,#5DCAA5)', iconBg: '#E1F5EE', iconColor: '#0F6E56' },
  injections: { icon: 'ti-needle',  bar: 'linear-gradient(90deg,#185FA5,#378ADD)', iconBg: '#E6F1FB', iconColor: '#185FA5' },
  syrups:     { icon: 'ti-bottle',  bar: 'linear-gradient(90deg,#7F77DD,#AFA9EC)', iconBg: '#EEEDFE', iconColor: '#534AB7' },
  ointments:  { icon: 'ti-bandage', bar: 'linear-gradient(90deg,#BA7517,#EF9F27)', iconBg: '#FAEEDA', iconColor: '#854F0B' },
};

const categories = [
  { id: 'all',        label: 'All Products', icon: 'ti-packages' },
  { id: 'tablets',    label: 'Tablets',      icon: 'ti-pill'     },
  { id: 'injections', label: 'Injections',   icon: 'ti-needle'   },
  { id: 'syrups',     label: 'Syrups',       icon: 'ti-bottle'   },
  { id: 'ointments',  label: 'Ointments',    icon: 'ti-bandage'  },
];

const products = [
  { 
    id: 1, 
    name: 'Paracetamol 500mg',  
    cat: 'tablets',    
    desc: 'Pain relief and fever reducer',         
    pkg: 'Strip of 10 tablets',  
    stock: 'In Stock'      
  },
  { 
    id: 2, 
    name: 'Amoxicillin 250mg',  
    cat: 'tablets',    
    desc: 'Antibiotic for bacterial infections',   
    pkg: 'Strip of 10 capsules', 
    stock: 'In Stock'      
  },
  { 
    id: 3, 
    name: 'Insulin Injection',  
    cat: 'injections', 
    desc: 'For diabetes management',               
    pkg: 'Vial 10ml',            
    stock: 'Limited Stock' 
  },
  { 
    id: 4, 
    name: 'Cough Syrup',        
    cat: 'syrups',     
    desc: 'Relieves cough and throat irritation',  
    pkg: '100ml bottle',         
    stock: 'In Stock'      
  },
  { 
    id: 5, 
    name: 'Antiseptic Cream',   
    cat: 'ointments',  
    desc: 'Prevents infection in minor cuts',      
    pkg: '20g tube',             
    stock: 'In Stock'      
  },
  { 
    id: 6, 
    name: 'Vitamin C Tablets',  
    cat: 'tablets',    
    desc: 'Immunity booster',                      
    pkg: 'Strip of 15 tablets',  
    stock: 'In Stock'      
  },
  { 
    id: 7, 
    name: 'Diclofenac Gel',     
    cat: 'ointments',  
    desc: 'Pain relief for joints and muscles',    
    pkg: '30g tube',             
    stock: 'In Stock'      
  },
  { 
    id: 8, 
    name: 'Cetirizine Tablets', 
    cat: 'tablets',    
    desc: 'Antihistamine for allergies',           
    pkg: 'Strip of 10 tablets',  
    stock: 'In Stock'      
  },
  // NEW PRODUCT ADDED
  { 
    id: 9, 
    name: 'Kcalric K27', 
    cat: 'tablets',    
    desc: 'L-Methylfolate, Vitamin K2-7, Cyanocobalamin, Pyridoxal-5 Phosphate, Lycopene, Calcium Citrate, Calcitriol, EPA-DHA & Vitamin D3 Tablets',         
    pkg: '10x1x10 Tablets (Alu-Alu)',             
    stock: 'In Stock'      
  },
];

const ProductCard = ({ product }) => {
  const [hovered, setHovered] = useState(false);
  const m = catMeta[product.cat] || catMeta.tablets;
  const inStock = product.stock === 'In Stock';

  return (
    <div
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        background: '#fff',
        border: `0.5px solid ${hovered ? 'rgba(29,158,117,.3)' : 'rgba(29,158,117,.15)'}`,
        borderRadius: 16,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        transform: hovered ? 'translateY(-5px)' : 'none',
        boxShadow: hovered ? '0 18px 44px rgba(15,110,86,.12)' : 'none',
        transition: 'transform .22s, box-shadow .22s, border-color .22s',
      }}
    >
      {/* colour bar */}
      <div style={{ height: 4, background: m.bar }} />

      <div style={{ padding: '1.2rem 1.1rem', display: 'flex', flexDirection: 'column', gap: 10, flex: 1 }}>
        {/* icon + badge */}
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 8 }}>
          <div style={{ width: 46, height: 46, borderRadius: 12, background: m.iconBg, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <i className={`ti ${m.icon}`} style={{ fontSize: 24, color: m.iconColor }} aria-hidden="true" />
          </div>
          <span style={{
            fontSize: 11, fontWeight: 600, padding: '3px 10px', borderRadius: 100, marginTop: 4,
            background: inStock ? '#E1F5EE' : '#FAEEDA',
            color:      inStock ? '#085041' : '#633806',
          }}>
            <i className={`ti ${inStock ? 'ti-circle-check' : 'ti-alert-circle'}`} style={{ fontSize: 11, marginRight: 3 }} aria-hidden="true" />
            {product.stock}
          </span>
        </div>

        <p style={{ fontFamily: "'Outfit',sans-serif", fontSize: 15, fontWeight: 600, color: '#085041', lineHeight: 1.3 }}>{product.name}</p>
        <p style={{ fontSize: 12.5, color: '#0F6E56', opacity: .75, lineHeight: 1.5 }}>{product.desc}</p>

        <div style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12, color: '#0F6E56', opacity: .7, marginTop: 'auto' }}>
          <i className="ti ti-box" style={{ fontSize: 14 }} aria-hidden="true" />
          {product.pkg}
        </div>

        <Link to="/contact" style={{ textDecoration: "none" }}>
          <button
            style={{
              width: '100%',
              padding: 9,
              borderRadius: 10,
              border: hovered ? '1.5px solid #085041' : '1.5px solid rgba(29,158,117,.3)',
              background: hovered ? '#085041' : 'rgba(29,158,117,.06)',
              color: hovered ? '#9FE1CB' : '#0F6E56',
              fontSize: 13,
              fontWeight: 500,
              fontFamily: "'DM Sans',sans-serif",
              cursor: 'pointer',
              transition: 'all .2s',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 6,
            }}
          >
            <i
              className="ti ti-send"
              style={{ fontSize: 15 }}
              aria-hidden="true"
            />
            Inquiry Now
          </button>
        </Link>
      </div>
    </div>
  );
};

const Products = () => {
  const [search, setSearch] = useState('');
  const [activeCat, setActiveCat] = useState('all');

  const filtered = products.filter(p => {
    const q = search.toLowerCase();
    return (p.name.toLowerCase().includes(q) || p.desc.toLowerCase().includes(q))
      && (activeCat === 'all' || p.cat === activeCat);
  });

  return (
    <section style={{ padding: '3rem 1.25rem', background: 'linear-gradient(150deg,#E1F5EE 0%,#f8fdfc 45%,#E6F1FB 100%)', minHeight: '100vh', fontFamily: "'DM Sans',sans-serif" }}>

      {/* Header */}
      <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
        <div style={{ display: 'inline-flex', alignItems: 'center', gap: 7, background: '#085041', color: '#9FE1CB', fontSize: 11.5, fontWeight: 500, letterSpacing: '.11em', textTransform: 'uppercase', padding: '5px 15px', borderRadius: 100, marginBottom: '.9rem' }}>
          <i className="ti ti-molecule" aria-hidden="true" /> Product Catalogue
        </div>
        <h1 style={{ fontFamily: "'Outfit',sans-serif", fontSize: '2.3rem', fontWeight: 700, color: '#085041' }}>
          Our <span style={{ color: '#1D9E75' }}>Products</span>
        </h1>
        <div style={{ width: 52, height: 3, background: 'linear-gradient(90deg,#1D9E75,#185FA5)', borderRadius: 2, margin: '.6rem auto .9rem' }} />
        <p style={{ fontSize: 14.5, color: '#0F6E56', maxWidth: 440, margin: '0 auto', opacity: .8, lineHeight: 1.6 }}>
          A comprehensive range of pharmaceutical products sourced from trusted, certified manufacturers
        </p>
      </div>

      {/* Search */}
      <div style={{ maxWidth: 420, margin: '0 auto 1.75rem', position: 'relative' }}>
        <i className="ti ti-search" style={{ position: 'absolute', left: 14, top: '50%', transform: 'translateY(-50%)', fontSize: 18, color: '#1D9E75', pointerEvents: 'none' }} aria-hidden="true" />
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder="Search products or descriptions…"
          style={{ width: '100%', padding: '11px 14px 11px 42px', border: '1.5px solid rgba(29,158,117,.25)', borderRadius: 100, fontSize: 14, fontFamily: "'DM Sans',sans-serif", background: '#fff', color: '#085041', outline: 'none' }}
        />
      </div>

      {/* Categories */}
      <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: 8, marginBottom: '2rem' }}>
        {categories.map(c => (
          <button key={c.id} onClick={() => setActiveCat(c.id)} style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            padding: '7px 16px', borderRadius: 100,
            border: '1.5px solid',
            borderColor: activeCat === c.id ? '#085041' : 'rgba(29,158,117,.2)',
            background: activeCat === c.id ? '#085041' : '#fff',
            color: activeCat === c.id ? '#9FE1CB' : '#0F6E56',
            fontSize: 13, fontWeight: 500, fontFamily: "'DM Sans',sans-serif", cursor: 'pointer', transition: 'all .2s',
          }}>
            <i className={`ti ${c.icon}`} style={{ fontSize: 16 }} aria-hidden="true" />
            {c.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      {filtered.length > 0 ? (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill,minmax(220px,1fr))', gap: 18 }}>
          {filtered.map(p => <ProductCard key={p.id} product={p} />)}
        </div>
      ) : (
        <div style={{ textAlign: 'center', padding: '4rem 1rem', color: '#0F6E56', opacity: .6 }}>
          <i className="ti ti-package-off" style={{ fontSize: 56, display: 'block', marginBottom: '1rem' }} />
          <h3 style={{ fontFamily: "'Outfit',sans-serif", fontSize: '1.1rem', fontWeight: 600, marginBottom: '.3rem' }}>No products found</h3>
          <p style={{ fontSize: 13 }}>Try adjusting your search or filter</p>
        </div>
      )}
    </section>
  );
};

export default Products;